import propTypes from 'prop-types';
import React, { forwardRef, useRef, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Typography } from '..';
import { CalendarIcon, ChevronDownIcon } from '../../../theme/icons';
import { useClickOutside } from '../../useOutsideClick';

const CustomButton = forwardRef(({
    onClick = () => null, iconClassName = "w-5 h-5 min-w-5",
    hideLabel = false,
    renderDate = null, className = "" }, ref = null,) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);

    useClickOutside(buttonRef, () => setIsOpen(false));

    const handleMonthSelect = (e) => {
        e.stopPropagation(); // Prevent event from bubbling up
        onClick();
        setIsOpen(!isOpen);
    }
 
    return (
        <span onClick={handleMonthSelect} ref={buttonRef} role="button" id="test"
            className={`h-fit border minn-w-sm rounded-md px-2 pr-4 justify-between py-1 flex items-center gap-4 hover:border-secondary-400 ${className} ${isOpen ? "border-primary-400" : "border-secondary-200"} ${hideLabel && isOpen ? "bg-primary-500 hover:bg-primary-300" : "hover:bg-primary-50"}`}>
            <div className='flex items-center gap-2'>
                <CalendarIcon className={`${iconClassName} ${hideLabel && isOpen ? "stroke-white stroke-2" : ""}`} />
                {!hideLabel && <Typography variant="base" text={renderDate} className="font-semibold text-secondary-500" />}
            </div>
            {!hideLabel && <ChevronDownIcon className={`w-4 h-4 ${isOpen ? 'rotate-180' : ''}`} />}
        </span>
    )
});

export const CalendarSelect = ({ handleUpdateMonth = () => null, startDate = null, iconClassName = "w-5 h-5 min-w-5", showMonthYearPicker = true, hideLabel = false, ...rest }) => {
    const handleChangeDate = (date) => handleUpdateMonth(date);
    return (<div className='monthlyPicker'  >
        <ReactDatePicker
            showMonthYearPicker={showMonthYearPicker}
            {...rest}
            selected={startDate}
            onChange={(date) => handleChangeDate(date)}
            customInput={<CustomButton startDate={startDate} iconClassName={iconClassName} hideLabel={hideLabel} {...rest} />}
        />
    </div>
    );
}

CalendarSelect.propTypes = {
    handleUpdateMonth: propTypes.func,
    startDate: propTypes.any,
    iconClassName: propTypes.string,
    showMonthYearPicker: propTypes.bool
}

CustomButton.propTypes = {
    onClick: propTypes.func,
    ref: propTypes.any,
}